import { Col, Row, Card, CardBody, CardTitle } from "reactstrap";

const IdentificationCard = ({ title, details }) => {
  return (
    <Card className="mb-4">
      <CardTitle tag="h5" style={{ paddingLeft: "10px" }}>
        {title}
      </CardTitle>
      <CardBody>
        {Object.entries(details).map(([key, value], index) => (
          <Row className="mb-3" key={index}>
            <Col
              xs={12}
              md={12}
              lg={4}
              className="mb-2 col-md-4"
              style={{ whiteSpace: "nowrap" }}
            >
              {key == "Objet social" ? (
                <i style={{ color: "#9d9c9c" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "11em",
                      paddingTop: "18px",
                    }}
                  >
                    {key} :
                  </span>
                </i>
              ) : key == "Classe immobilisation" ? (
                <i style={{ color: "#9d9c9c" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "11em",
                      paddingTop: "18px",
                    }}
                  >
                    {key} :
                  </span>
                </i>
              ) : (
                <i style={{ color: "#9d9c9c" }}>
                  <span style={{ display: "inline-block", width: "11em" }}>
                    {key} :
                  </span>
                </i>
              )}
            </Col>
            <Col xs={12} md={12} lg={8} className="mb-2 col-md-8">
              <span
                style={{
                  paddingInlineStart: "3em",
                  whiteSpace: "nowrap",
                  fontFamily: "sans-serif",
                }}
              >
                {typeof value === "number" ? (
                  renderValue(
                    value
                      .toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })
                      .replace("€", "")
                  )
                ) : key === "Objet social" ? (
                  <span
                    style={{
                      paddingLeft: "40px",
                      display: "flex",
                      whiteSpace: "pretty",
                    }}
                  >
                    {value}
                  </span>
                ) : key === "Classe immobilisation" ? (
                  <span
                    style={{
                      paddingLeft: "40px",
                      display: "flex",
                      whiteSpace: "pretty",
                    }}
                  >
                    {value}
                  </span>
                ) : (
                  renderValue(value)
                )}
              </span>
            </Col>
          </Row>
        ))}
      </CardBody>
    </Card>
  );
};

const renderValue = (value) => {
  if (value == null || (typeof value === "string" && value.trim() === "")) {
    return "";
  } else if (
    value === "Validé" ||
    value === "Validée" ||
    value === "Finalisée" ||
    value === "Dossier de souscription CGP"
  ) {
    return (
      <span
        className="bg-success badge bg-secondary"
        style={{ fontSize: "100%" }}
      >
        {value}
      </span>
    );
  } else if (
    value === "En attente" ||
    value === "Commercialisation" ||
    value === "Optionnelle - à confirmer" ||
    value === "En cours"
  ) {
    return (
      <span className="bg-info badge bg-secondary" style={{ fontSize: "100%" }}>
        {value}
      </span>
    );
  } else if (
    value === "Ferme - en attente d'allocation" ||
    value === "Ferme - Rompu à rembourser" ||
    value === "Abandonnée" ||
    value === "Radiée" ||
    value === "Annulée" ||
    value === "Cloturée"
  ) {
    return (
      <span
        className="badge-soft-danger badge bg-secondary"
        style={{ fontSize: "100%" }}
      >
        {value}
      </span>
    );
  } else {
    return value;
  }
};

export default IdentificationCard;
